const list_items = document.querySelectorAll(".section__global__locations__area__list__item");

for (const item of list_items) {
    item.addEventListener("click", function (event) {
        event.preventDefault();
        const location = this.querySelector(".section__global__locations__area__list__item--location");
        const open = location.classList.contains("open");
        if (open) {
            removeOpenClass(this);
        }
        else {
            moveOpenClass(this);
        }
    });
    //The nested details container should be able to be clicked and dragged without firing parent close event. 
    //That's what this function does. Allows tel and mailto links to fire but immediately stops their propagation bubbling.
    const itemLocation = item.querySelector('.section__global__locations__area__list__item__details');
    itemLocation.addEventListener("click", function (event) {
        event.stopPropagation();
    })
}

function moveOpenClass(newItem) {
    for (const item of list_items) {
        const location = item.querySelector(".section__global__locations__area__list__item--location");
        if (location.classList.contains("open")) {
            location.classList.remove("open")
        }
    }
    const newItemLocation = newItem.querySelector(".section__global__locations__area__list__item--location");
    newItemLocation.classList.add("open");
}

function removeOpenClass(item) {
    const itemLocation = item.querySelector(".section__global__locations__area__list__item--location");
    if (itemLocation.classList.contains("open")) {
        itemLocation.classList.remove("open")
    }
}

//When the user clicks the cta, move the view window down. 
const cta = document.getElementById('exploreOfficesCTA');
cta.addEventListener('click', function () {
    const globalOfficesContainer = document.querySelector('.section__global__locations');

    globalOfficesContainer.scrollIntoView({
        behavior: 'smooth',
        alignToTop: true
    })
})


//Map animation stuff
const circles = gsap.utils.toArray('.svg_circle');
gsap.utils.shuffle(circles);

const tl = gsap.timeline({ repeat: -1, repeatDelay: 1, paused: true });
for (let i = 0; i < circles.length; i++) {
    let placement = i === 0 ? "" : "<1.25"
    tl.to(circles[i], { attr: { r: 10, cy: -15 }, duration: .75, repeat: 1, repeatDelay: .5, yoyo: true, ease: "back.inOut(1.7)" }, placement)
}

tl.play();